const objFunc = () => {
  return {
    incomeList: [],
    incomeIndex: undefined,
    rent: undefined,
    utilities: undefined,
    insurance: undefined,
    otherExpenses: undefined,
    signatureInitials: undefined
  }
}

export default objFunc()

export const defaultObj = objFunc()
